import styled from '@emotion/styled';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const FlowWrapper = styled.div(() =>
  mq({
    display: 'grid',
    gridTemplateColumns: ['1fr', '1fr', '320px auto', '320px auto'],
    alignItems: 'center',
    gridGap: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
      defaultTheme.spacing.xxl,
    ],
  }),
);

export const FlowImage = styled.div(() =>
  mq({
    width: ['100%', '100%', 'auto', 'auto'],
    '& img': {
      width: '100%',
      height: 'auto',
    },
  }),
);
